<template>
  <div>
    <form class="reset-form" @submit.prevent="resetUserToCohort">
      <h1>Reset User Progress</h1>
      <label for="user-id">Add user id or email:</label>
      <textarea
        id="user-id"
        ref="userIds"
        v-model="userID"
        type="text"
        placeholder="Add one or more user id or email"
        required
      />
      <div>
        <label for="payment-unlock"
          >Payment Unlock
          <input
            id="payment-unlock"
            v-model="paymentUnlock"
            type="checkbox"
            class="payment-unlock-checkbox"
          />
        </label>
      </div>
      <label for="cohort-id">Select the cohort:</label>
      <VueSelect
        v-model="selectCohort"
        :options="cohortOptions"
        placeholder="Select any Cohort"
        label="name"
      />
      <button
        class="button-green link border p-3 px-12 mt-3 rounded-full bg-green text-white font-bold"
      >
        Reset User Progress
      </button>
    </form>
  </div>
</template>

<script>
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"

export default {
  components: {
    VueSelect,
  },
  data() {
    return {
      paymentUnlock: false,
      userID: "",
      cohortOptions: [],
      selectCohort: undefined,
    }
  },
  mounted() {
    this.$refs.userIds.focus()
    this.axios({
      method: "get",
      url: `${siteConfig.siteURL}cohorts/?pagination=false`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-access-token": localStorage.token,
      },
    }).then(res => {
      const cohorts = res.data.items
      this.cohortOptions = cohorts.map(item => ({
        id: item.id,
        name: item.name,
      }))
    })
  },
  methods: {
    async resetUserToCohort() {
      const v = await this.$swal({
        text: `Are you sure you want to reset progress of these users on this cohort: ${this.selectCohort.name}?`,
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: true,
          confirm: {
            text: "Yes",
            value: true,
          },
        },
      })
      if (!v) {
        return
      }
      const payload = {
        users_list: this.userID,
      }
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}admin/reset_user_cohort/${
          this.selectCohort.id
        }?payment_unlock=${+this.paymentUnlock}`,
        data: payload,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          const users_not_found = res.data.users_not_found.length
          if (users_not_found > 0) {
            this.$noty.warning(
              "Some user's are not able to reset, Please review your information."
            )
          } else {
            this.$noty.success("Users successfully reset to the cohort")
          }
        })
        .catch(() => {
          this.$noty.error("Failed to reset user cohort record")
        })
    },
  },
}
</script>

<style scoped>
.reset-form {
  max-width: 500px;
  margin: auto;
  padding: 10px;
}
textarea {
  width: 100%;
  height: 150px;
  padding: 10px;
  border: solid 1px rgb(107, 99, 99);
  border-radius: 5px;
  font-size: 15px;
}
textarea:focus {
  border: 1px solid green;
  box-shadow: 0 0 5px green;
}
label {
  display: block;
  padding: 10px 0px;
  font-size: 16px;
  text-align: left;
}
.payment-unlock-checkbox {
  width: inherit;
  margin-left: 10px;
}
</style>
